"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSelect = void 0;
class CustomSelect extends HTMLElement {
    constructor() {
        super();
        this.$select = null;
        this.selectOptions = null;
        this.selectOptionsList = null;
        this.selectTrigger = null;
        this.selectTriggerText = null;
        this.isFirstOptionSelect = true;
        this.activeOption = 0;
        this.toggleCustomSelect = () => {
            this.classList.contains('custom-select--opened') ? this.close() : this.open();
        };
        this.handleTriggerKeydown = (e) => {
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                this.open();
            }
        };
        this.handleOptionBlur = (e) => {
            e.preventDefault();
            e.stopPropagation();
            const relatedTarget = e.relatedTarget;
            if (!relatedTarget || !this.contains(relatedTarget)) {
                this.close();
            }
        };
        this.handleOptionKeydown = (index) => (e) => {
            var _a, _b;
            if (e.key === 'Tab' || e.key === 'Shift')
                e.preventDefault();
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                this.focusOption(index - 1 >= 0 ? index - 1 : (((_a = this.selectOptionsList) === null || _a === void 0 ? void 0 : _a.length) || 1) - 1);
            }
            else if (e.key === 'ArrowDown') {
                e.preventDefault();
                this.focusOption(index + 1 < (((_b = this.selectOptionsList) === null || _b === void 0 ? void 0 : _b.length) || 0) ? index + 1 : 0);
            }
            else if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                this.selectOption(index);
            }
        };
        this.handleEscape = (e) => {
            if (e.key === 'Escape')
                this.close();
        };
        this.handleScroll = () => {
            this.close();
        };
        this.handleResize = () => {
            var _a;
            let maxWidth = 0;
            (_a = this.selectOptionsList) === null || _a === void 0 ? void 0 : _a.forEach($option => {
                const optionComputedStyle = window.getComputedStyle($option);
                const padding = parseFloat(optionComputedStyle.paddingLeft) + parseFloat(optionComputedStyle.paddingRight) + 2; // border
                let widthOption = 0;
                $option.querySelectorAll('.custom-select__options-item-text').forEach(($item) => {
                    const computedStyle = window.getComputedStyle($item);
                    widthOption += $item.offsetWidth + parseFloat(computedStyle.marginLeft) + parseFloat(computedStyle.marginRight);
                });
                widthOption += padding;
                maxWidth = Math.max(maxWidth, widthOption);
            });
            this.style.width = `${maxWidth}px`;
        };
    }
    connectedCallback() {
        this.init();
    }
    disconnectedCallback() {
        this.removeEventListeners();
    }
    init() {
        var _a, _b, _c;
        this.$select = this.querySelector('select');
        this.selectOptions = this.querySelector('.custom-select__options');
        this.selectOptionsList = this.querySelectorAll('.custom-select__options-item');
        this.selectTrigger = this.querySelector('.custom-select__trigger');
        this.selectTriggerText = ((_a = this.selectTrigger) === null || _a === void 0 ? void 0 : _a.querySelector('.custom-select__trigger-text')) || null;
        this.activeOption =
            Array.from(((_b = this.$select) === null || _b === void 0 ? void 0 : _b.querySelectorAll('option')) || []).findIndex(item => item.selected) || 0;
        if (this.activeOption === -1)
            this.activeOption = 0;
        this.selectOption(this.activeOption);
        (_c = this.selectOptionsList) === null || _c === void 0 ? void 0 : _c.forEach($option => $option.setAttribute('tabindex', '-1'));
        // this.handleResize();
        this.addEventListeners();
    }
    addEventListeners() {
        // window.addEventListener('resize', this.handleResize);
        var _a, _b, _c;
        (_a = this.selectTrigger) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.toggleCustomSelect);
        (_b = this.selectTrigger) === null || _b === void 0 ? void 0 : _b.addEventListener('keydown', this.handleTriggerKeydown);
        (_c = this.selectOptionsList) === null || _c === void 0 ? void 0 : _c.forEach((option, index) => {
            option.addEventListener('click', () => this.selectOption(index));
            option.addEventListener('blur', this.handleOptionBlur);
            option.addEventListener('keydown', this.handleOptionKeydown(index));
        });
    }
    removeEventListeners() {
        var _a, _b, _c;
        // window.removeEventListener('resize', this.handleResize);
        (_a = this.selectTrigger) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.toggleCustomSelect);
        (_b = this.selectTrigger) === null || _b === void 0 ? void 0 : _b.removeEventListener('keydown', this.handleTriggerKeydown);
        (_c = this.selectOptionsList) === null || _c === void 0 ? void 0 : _c.forEach((option, index) => {
            option.removeEventListener('click', () => this.selectOption(index));
            option.removeEventListener('blur', this.handleOptionBlur);
            option.removeEventListener('keydown', this.handleOptionKeydown(index));
        });
        this.removeEventListener('keydown', this.handleEscape);
    }
    open() {
        var _a, _b, _c, _d;
        this.classList.add('custom-select--opened');
        (_a = this.selectTrigger) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'true');
        (_b = this.selectOptions) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-hidden', 'false');
        (_d = (_c = this.selectOptionsList) === null || _c === void 0 ? void 0 : _c[this.activeOption]) === null || _d === void 0 ? void 0 : _d.focus();
        this.addEventListener('keydown', this.handleEscape);
        window.addEventListener('scroll', this.handleScroll, { once: true, passive: true });
    }
    close(doFocus = true) {
        var _a, _b, _c;
        this.classList.remove('custom-select--opened');
        (_a = this.selectTrigger) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'false');
        (_b = this.selectOptions) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-hidden', 'true');
        if (doFocus)
            (_c = this.selectTrigger) === null || _c === void 0 ? void 0 : _c.focus();
        this.removeEventListener('keydown', this.handleEscape);
        window.removeEventListener('scroll', this.handleScroll);
    }
    selectOption(index) {
        var _a, _b, _c, _d;
        const selectedOption = (_a = this.selectOptionsList) === null || _a === void 0 ? void 0 : _a[index];
        if (selectedOption) {
            const link = selectedOption.getAttribute('data-option-link');
            if (link) {
                window.location.href = link;
                return;
            }
        }
        this.activeOption = index;
        if (this.selectTriggerText && this.selectOptionsList) {
            this.selectTriggerText.textContent =
                ((_b = this.selectOptionsList[index].querySelector('.custom-select__options-item-text')) === null || _b === void 0 ? void 0 : _b.textContent) || '';
        }
        (_c = this.selectOptionsList) === null || _c === void 0 ? void 0 : _c.forEach(option => option.removeAttribute('aria-selected'));
        (_d = this.selectOptionsList) === null || _d === void 0 ? void 0 : _d[index].setAttribute('aria-selected', 'true');
        if (this.$select && this.$select.selectedIndex !== index) {
            this.$select.selectedIndex = index;
            this.$select.dispatchEvent(new Event('change'));
        }
        this.isFirstOptionSelect ? this.close(false) : this.close();
        this.isFirstOptionSelect = false;
    }
    focusOption(index) {
        var _a, _b;
        (_b = (_a = this.selectOptionsList) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.focus();
    }
}
exports.CustomSelect = CustomSelect;
